import DomainModel from "./DomainModel";

export default class FoClosedCases extends DomainModel {
    constructor(
        private id: string,
        private claimNumber: string,
        private insuredName: string,
        private insuredState: string,
        private insuredDistrict: string,
        private investigatorName: string,
        private caseTypeName: string,
        private clientName: string
    ) {
        super();
    }

    getId = () => this.id;
    getClaimNumber = () => this.claimNumber;
    getInsuredName = () => this.insuredName;
    getInsuredState = () => this.insuredState;
    getInsuredDistrict = () => this.insuredDistrict;
    getInsuredLocation = () => `${this.insuredState}, ${this.insuredDistrict}`;

    getInvestigatorNames = (): string[] =>
        (Array.isArray(this.investigatorName)
            ? this.investigatorName
            : [this.investigatorName]
        ).filter(Boolean) as string[];

    getInvestigatorName = () =>
        Array.isArray(this.investigatorName)
            ? this.investigatorName.join(", ")
            : this.investigatorName;

    getCaseTypeName = () => this.caseTypeName;
    getClientName = () => this.clientName;
}

export class FoOpenCases extends FoClosedCases {
    constructor(
        id: string,
        claimNumber: string,
        insuredName: string,
        insuredState: string,
        insuredDistrict: string,
        investigatorName: string,
        caseTypeName: string,
        clientName: string,
        private investigator: {
            investigator_name: string;
            investigator_status: string;
        }[] = []
    ) {
        super(
            id,
            claimNumber,
            insuredName,
            insuredState,
            insuredDistrict,
            investigatorName,
            caseTypeName,
            clientName
        );
    }

    getInvestigators = () => this.investigator;

    getInvestigatorNames = (): string[] =>
        this.investigator.map((item) => item.investigator_name).filter(Boolean);

    getInvestigatorStatuses = (): string[] =>
        this.investigator.map((item) => item.investigator_status).filter(Boolean);

    getInvestigatorStatus = () =>
        this.investigator
            .map((item) => item.investigator_status)
            .filter(Boolean)
            .join(", ");
}